import "components/ui/TitleWithIcon/TitleWithIcon.scss";
import * as Proptypes from "prop-types";

function TitleWithIcon({ title, headingSize, hasBottomMargin, children }) {

  let heading;
  if (headingSize === 'small') {
    heading = <h3>{ title }</h3>
  } else {
    heading = <h1>{ title }</h1>
  }

  return (
    <div className={ `title-with-icon ${ hasBottomMargin ? 'title-with-icon--margin' : '' }` }>
      <div className={ `title-with-icon__icon` }>
        { children }
      </div>

      { heading }
    </div>
  );
}

TitleWithIcon.defaultProps = {
  headingSize: 'large',
  hasBottomMargin: false
}

TitleWithIcon.propTypes = {
  title: Proptypes.string,
  headingSize: Proptypes.string,
  hasBottomMargin: Proptypes.bool
}

export default TitleWithIcon;
